import PropTypes from 'prop-types';
import React from 'react';
import { connect as connectR } from 'react-redux';
import { Link } from 'react-router';
import { Button, Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import LargeCard from '../main/large-card';
import LeftSide from '../main/left-side';
import RigthSide from '../main/right-side';
import TitleCard from '../main/title-card';
import ApplianceBasicForm from './forms/appliance-basic-form';
import Postit from '../main/postit';
import OrderPostit from '../locations/forms/order-postit';
import translate from '../translate';
import { CONTROL_TYPE } from '../../util/enums';
import {
    CreateAppliance as CreateApplianceCall,
    LoadAppliancesByLocation,
    resetApplianceRequestStates,
} from '../../store/applianceSlice';
import { LoadLocationsForMansionId } from '../../store/locationsSlice';
import {
    LoadConnectedSwitchSerialNumbers,
    LoadSwitchSerialNumbers,
} from '../../store/serialNumbersSlice';
import { REQUEST_FAILURE } from '../../store/network/managedRequest';
import { LoadMansions } from '../../store/mansionsSlice';
import { MaybeLoadContractDetails } from '../../store/userDetailsSlice';
import { goToLocation } from '../../nav/navigationService';
import { PbRequest } from '../../store/pbRequest';
import withParams from '../../nav/withParams';

const defaultFields = {
    state: 'OFFLINE',
    appliance_type: 'WASHING_MACHINE',
    location_id: '',
    local_name: '',
    short_name: '',
    control_type: CONTROL_TYPE.power,
    serial_number: '',
    contractual_type: null,
};

class CreateAppliance extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        params: PropTypes.shape({
            location_id: PropTypes.string,
            object_id: PropTypes.string,
        }).isRequired,
        LoadAppliancesByLocation: PropTypes.func.isRequired,
        LoadSwitchSerialNumbers: PropTypes.func.isRequired,
        CreateAppliance: PropTypes.func.isRequired,
        resetApplianceRequestStates: PropTypes.func.isRequired,
        createRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        LoadLocationsForMansionId: PropTypes.func.isRequired,
        LoadMansions: PropTypes.func.isRequired,
        MaybeLoadContractDetails: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        const appliance = _.extend({}, defaultFields, {
            location_id: parseInt(props.params.location_id, 10),
        });

        this.state = {
            appliance: appliance,
        };
    }

    componentDidMount() {
        this.props.MaybeLoadContractDetails();
        this.props.resetApplianceRequestStates();
        this.props.LoadSwitchSerialNumbers(
            Number(this.props.params.location_id)
        );
        this.props.LoadConnectedSwitchSerialNumbers(
            Number(this.props.params.location_id)
        );
        this.props.LoadLocationsForMansionId(
            Number(this.props.params.object_id)
        );
        this.props.LoadAppliancesByLocation(
            Number(this.props.params.location_id)
        );
        this.props.LoadMansions();
    }

    _handleWholeForm = (component, submit) => {
        const stateAppliance = this.state.appliance;
        if (!!component) {
            const info = component;
            const appliance = _.extend(stateAppliance, {
                appliance_type: info.appliance_type,
                local_name: info.local_name,
                short_name: info.short_name,
                control_type: info.control_type,
                serial_number: info.serial_number,
                contractual_type: info.contractual_type,
                product_code: info.product_code,
                model_group: info.model_group,
                manufacturing_batch: info.manufacturing_batch,
            });
            this.setState({
                appliance: appliance,
                isApplianceFormValid: info._valid,
            });
        } else {
            if (this.state.isApplianceFormValid) {
                const applianceToSave = _.extend(stateAppliance, {
                    location_id: this.props.params.location_id,
                    state: 'OFFLINE',
                });
                this.props.CreateAppliance(applianceToSave, () =>
                    this._handleCreateSuccess()
                );
            } else {
                this.setState({ forceValidation: true });
            }
        }
    };

    _handleCreateSuccess = () => {
        goToLocation(
            this.props.params.object_id,
            this.props.params.location_id
        );
    };

    render() {
        const hasError = this.props.createRequest.status === REQUEST_FAILURE;

        return (
            <Row>
                <LeftSide addClass="">
                    <TitleCard
                        title={[
                            this.props.strings.add1,
                            this.props.strings.add2,
                        ]}
                        left={{
                            content: (
                                <Link
                                    to={
                                        '/objects/' +
                                        this.props.params.object_id +
                                        '/' +
                                        this.props.params.location_id
                                    }
                                    className="icon icon-wew-arrow-left icon-sm"
                                />
                            ),
                            title: this.props.strings.cancel,
                        }}
                    />
                    <OrderPostit />
                </LeftSide>
                <Col xs={6} sm={6} md={6} lg={6}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <LargeCard title={this.props.strings.headline}>
                                <ApplianceBasicForm
                                    handleChange={this._handleWholeForm}
                                    location_id={parseInt(
                                        this.props.params.location_id,
                                        10
                                    )}
                                    forceValidation={this.state.forceValidation}
                                />
                            </LargeCard>
                        </Col>
                    </Row>
                    <Row className="spacer-tb">
                        <Col xs={12} sm={12} md={12} lg={12}>
                            {hasError && (
                                <div className="alert alert-danger pull-left">
                                    {this.props.strings.generalError} (
                                    {this.props.createRequest.errors})
                                </div>
                            )}
                            <Button
                                onClick={() =>
                                    this._handleWholeForm(null, true)
                                }
                                disabled={!this.state.isApplianceFormValid}
                                className="btn btn-primary pull-right"
                                data-testid="create-appliance-button"
                            >
                                {this.props.strings.save}
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <RigthSide addClass="">
                    <Postit title={this.props.strings.Postit1.title}>
                        <p>{this.props.strings.Postit1.text1}</p>
                        <ul>
                            <li>{this.props.strings.Postit1.text2}</li>
                            <li>{this.props.strings.Postit1.text3}</li>
                            <li>{this.props.strings.Postit1.text4}</li>
                            <li>{this.props.strings.Postit1.text5}</li>
                        </ul>
                    </Postit>
                </RigthSide>
            </Row>
        );
    }
}

export default connectR(
    (store) => ({
        createRequest: store.pbRequest[PbRequest.CREATE_APPLIANCE],
    }),
    {
        LoadAppliancesByLocation,
        LoadSwitchSerialNumbers,
        LoadConnectedSwitchSerialNumbers,
        CreateAppliance: CreateApplianceCall,
        resetApplianceRequestStates,
        LoadLocationsForMansionId,
        LoadMansions,
        MaybeLoadContractDetails,
    }
)(translate('CreateAppliance')(withParams(CreateAppliance)));
